import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

export const DevPassword = (props: IIconProps) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.0132 15.1224C18.51 15.1224 18.9132 14.7192 18.9132 14.2224V12C18.9132 11.5032 18.51 11.1 18.0132 11.1H11.1828C10.794 9.8196 9.6156 8.8788 8.2092 8.8788C6.4884 8.8788 5.088 10.2792 5.088 12C5.088 13.722 6.4884 15.1224 8.2092 15.1224C9.6156 15.1224 10.794 14.1816 11.1828 12.9H13.7172V14.2224C13.7172 14.7192 14.1204 15.1224 14.6172 15.1224C15.114 15.1224 15.5172 14.7192 15.5172 14.2224V12.9H17.1132V14.2224C17.1132 14.7192 17.5164 15.1224 18.0132 15.1224ZM6.7992 0H17.202C21.2676 0 24 2.8536 24 7.1004V16.9008C24 21.1476 21.2676 24 17.2008 24H6.7992C2.7324 24 0 21.1476 0 16.9008V7.1004C0 2.8536 2.7324 0 6.7992 0ZM6.8869 12.0011C6.8869 11.2715 7.4809 10.6787 8.2093 10.6787C8.9377 10.6787 9.5317 11.2715 9.5317 12.0011C9.5317 12.7295 8.9377 13.3223 8.2093 13.3223C7.4809 13.3223 6.8869 12.7295 6.8869 12.0011Z"
      fill="currentColor"
    />
  </Icon>
);

export default DevPassword;
